import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { PremiumTrialMeta } from "../../models/state/meta/PremiumTrialMeta";
import PremiumTrialsStateSlice from "../../models/state/PremiumTrialsStateSlice";
import TrialsState from "../../models/state/trials/TrialsState";
import * as metaStateSelectors from "./meta";
import * as trialsStateSelectors from "./trials";

export const getTrialsState = (state: PremiumTrialsStateSlice): TrialsState => {
  return state.trials;
};

// wrong answers trial

export const hasWrongAnswersPremiumTrial: (
  arg0: PremiumTrialsStateSlice
) => boolean = composeSelector(
  getTrialsState,
  trialsStateSelectors.hasWrongAnswersPremiumTrial
);

export const getWrongAnswersSessionsInitiallyGranted: (
  arg0: PremiumTrialsStateSlice
) => number = composeSelector(
  getTrialsState,
  trialsStateSelectors.getWrongAnswersSessionsInitiallyGranted
);

export const getWrongAnswersSessionsRemaining: (
  arg0: PremiumTrialsStateSlice
) => number = composeSelector(
  getTrialsState,
  trialsStateSelectors.getWrongAnswersSessionsRemaining
);

export const canStudyWrongAnswersSession: (
  arg0: PremiumTrialsStateSlice
) => boolean = composeSelector(
  getTrialsState,
  trialsStateSelectors.canStudyWrongAnswersSession
);

export const userHasFinishedWrongAnswersTrial: (
  arg0: PremiumTrialsStateSlice
) => boolean = composeSelector(
  getTrialsState,
  trialsStateSelectors.userHasFinishedWrongAnswersTrial
);

// meta
export const getMetaState = (
  state: PremiumTrialsStateSlice
): PremiumTrialMeta => {
  return state.meta as unknown as PremiumTrialMeta;
};

// fetch
export const trialsAreFetching: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialsAreFetching);
export const trialsFetchSucceeded: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialsFetchSucceeded);
export const trialsFetchErrored: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialsFetchErrored);
export const trialsFetchFinished: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialsFetchFinished);
export const trialsNeedFetching: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialsNeedFetching);
//update
export const trialIsUpdating: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialIsUpdating);
export const trialUpdateSucceeded: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialUpdateSucceeded);
export const trialUpdateErrored: (arg0: PremiumTrialsStateSlice) => boolean =
  composeSelector(getMetaState, metaStateSelectors.trialUpdateErrored);
